import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { IconSprite } from './components/kit/IconSprite';
import { ToastProvider } from './components/kit/Toast';

// Порядок важен: токены, затем база кита, затем свои правила.
// Первые два — копии кита и не правятся (см. CLAUDE.md, «Интерфейс»).
import './styles/tokens.css';
import './styles/ui-kit-base.css';
import './styles/module.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Объёмы крошечные, перезапрос дешевле рассинхрона
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <IconSprite />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
